import { Button } from "../ui/button";

export default function ChatCookieConsent({ onAccept }: { onAccept: () => void }) {
    return (
        <div className="relative flex h-full flex-col items-center justify-center">
            <p className="px-4 text-center text-slate-100">
                Mit Ihrer Zustimmung werden Ihre Nachrichten über OpenRouter verarbeitet und für Verlauf und Qualität gespeichert. Sie können Ihre Einwilligung im Chat widerrufen. Bei Fragen schreiben Sie an <a href="mailto:info@stellplatz-zingst.de">info@stellplatz-zingst.de</a>.
            </p>
            <div className="mt-6 flex gap-2">
                <Button
                    variant={"secondary"}
                    onClick={onAccept}
                    className=""
                >
                    Chat aktivieren
                </Button>
            </div>
        </div>
    );
}